import { useQuery } from '@tanstack/react-query';
import { apiClient as api } from '@plerionhq/design-system';

export interface UserModel {
  id: string;
  name?: string;
  email: string;
  roleId?: string[];
  roles: { level: string; roleId: string; tenantIds?: string[] }[];
  organizationId: string;
  tenantId: string;
  status?: 'invited' | 'active' | 'inactive';
  emailVerified?: boolean;
  mfaEnabled?: boolean;
  mfaMethod?: { [key: string]: string };
  authorizedDevices?: string[];
  antiPhishingCode?: string;
  lastLoggedIn?: string;
  passwordChangedAt?: string;
  createdAt?: string;
  updatedAt?: string;
  permissions?: string[];
  authorizedDevicesCount?: number;
  chatAppUserHash?: string;
}
export function useUserProfile() {
  return useQuery({
    queryKey: ['currentUser'],
    queryFn: () =>
      api.get<UserModel>(`/api/base/users/me`).then((res) => res.data),
  });
}
